import React from "react";
import {
  Button,
  Drawer,
  message,
  Typography

 
} from "antd";
const { Text } = Typography;
import { CONSTANTS } from "../../../utils/constant";
import {  currentPrescriptionTab ,switchPrescriptionTabs} from "store/slice/tabs-slice";
import { setPublishClicked } from "store/slice/videoConsultation-slice";
import MedicalTestform from "./MedicalTestForm";
import MedicalTestTable from "./MedicalTestTable";
import {addMedicalTest}  from "store/slice/medicaltest-slice";
import PublishPrescriptionPopup from "./PublishPrescriptionPopup";
import "./MedicalTest.scss";
import { connect } from "react-redux";
import api from "utils/api";




 class MedicalTestTab extends React.Component {
  form = React.createRef();
 
  constructor(props) {
    super(props);
    this.state = {
      open_publish_modal:false,
        isloading:true,
        is_save:false,
        edit_array:[],
        test_array:[],
        search_suggestion:[],
        is_edit:false,
        form_saved:"save",
        preview_medical_test:false,
        t_table_data:[]
     
    };
    this.form = React.createRef();
  }

  
    componentDidMount = () => { 
      typeof this.props.formAction == "function" && this.props.formAction(false)
      this.getConsultationDetails()
      api
    
      this.getConsultationDetails()
     }
  
    getConsultationDetails = () => {     
      api.get_consultation_details({app_id:this.props.appointment_id,type:"prescription"})
      .then((response) => {
        if(response.status == 200){
            let test_data=response?.data?.data?.results?.prescription?.[0]
            if(test_data?.is_medical_test){
              typeof this.props?.visiblePublish == "function" &&
              this.props.visiblePublish();
              typeof this.props.handleFunction == "function" && this.props.handleFunction({ is_prescription: true });
              this.props.setPublishClicked({ [this.props.appointment_id]: true });

              test_data=test_data.medical_test?.map(item=>{
                return{
                  test_id:item?.test_id+"_"+item?.test_name,
                  instructions: item?.doctor_instructions
                }
              })
              this.setState({t_table_data:test_data})  
            }
            
        }
        else{
          message.error(response.data.message, ErrorDuration)
        }
      })
    }

    add_test = (data) => {
            this.setState({
              form_saved:"add",
              test_name:[],
              test_array:data,
              edit_array:[],
             
              
            })
    }

  edit_test = (data) => {
    this.setState({
      test_array:[],
      edit_array:data,
      is_edit:true,
      form_saved:"edit"
    })
  }

  update_test=(data,action)=>{
     let arr= this.state.edit_array;
     arr["test_id"]=data.test_id
      if(action=="cancel"){
        this.setState({test_array:this.state.edit_array,is_edit:false,form_saved:"update"})
        

      }else{
        this.setState({test_array:data,is_edit:false,form_saved:"update"})
      }
      this.setState({edit_array:[]})
    }

 
 

saveTest=(data)=>{
  this.setState({is_save:true})
  typeof this.props.formAction == "function" && this.props.formAction(false)
  if(this.state.is_edit){
    message.error("Please add/cancel the exisiting changes .", ErrorDuration)
    this.setState({is_save:false})
  }else{

    let test_data=data.map(item=>{
      return{
      if_others:parseInt(item?.test_id?.split("_")?.[0])=="9"?item?.test_id?.split("_")?.[1]:"" ,
      test_id:parseInt(item?.test_id?.split("_")?.[0])  ,
      instructions:item?.instructions?.trim() || "",
      }})
      let prescription_data={
              data:test_data,
              is_completed: true,
              prescription_mail: false,
              is_prescription_required:true,
              type: "medical_test",
              appointment_id:this.props.appointment_id ,
      }
      api
      .prescription_submit(prescription_data)
      .then((res) => {
        if(res.status==200){
        message.warning("Please wait few seconds, saving the prescription", ErrorDuration);
        
        this.viewFile()
        typeof this.props?.visiblePublish == "function" &&
        this.props.visiblePublish();
        typeof this.props.handleFunction == "function" && this.props.handleFunction({ is_prescription: true });
        this.props.setPublishClicked({ [this.props.appointment_id]: true });
        }else{
          message.error(res.data.message, ErrorDuration)
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        // this.setState({ isLoading: false, isinnerLoading: false });
      });

  }
}

viewFile() {
  api
    .preview_medical_test({ app_id: this.props.appointment_id,type:"medical_test" })
    .then((res) => {
      if (res.status == 200) {
        this.setState({is_save:false})
        typeof this.props?.visiblePublish == "function" && this.props.visiblePublish()
        let file_path = res.data?.data || {};
        let final_filepath = file_path + "#toolbar=0&scrollbar=0";
        this.setState({
          preview_medical_test: true,
          medical_test_data: final_filepath,
        });
      } else {
        
        message.error("Failed to save prescription", ErrorDuration);
      }
      this.setState({ isSaving: false });
    })
    .catch((error) => {
      this.setState({ isSaving: false });
      message.error("Failed to save prescription", ErrorDuration);
    });
}
openPreview=()=>{
  return(
    <Drawer
    width={"70%"}
    closable={false}
    mask={false}
    open={this.state.preview_medical_test}
    title={
      <div className="pres-button">
        <div>{CONSTANTS.PRIEW_MEDICAL_TEST}</div>
        <div className="button-wrapper" style={{display:"flex",flexDirection:"row-reverse",alignItems:"center"}} >
          <Button
            onClick={() => this.setState({ preview_medical_test: false })}
            className="cancel-btn"
            style={{ float: "right", margin: "10px" }}
          >
            {CONSTANTS.CLOSE}
          </Button>
          {!this.props.is_prescription_report && 
            <Button
               onClick={() => this.setState({open_publish_modal:true})}
               className="confirm-btn"
               style={{ float: "right", margin: "10px" }}
            >
              {CONSTANTS.PUBLISH}
            </Button> }
            {this.props.is_prescription_report &&
            <Text type={"warning"}>{CONSTANTS.PRESCRIPTION_PUBLISH_IN_PROGRESS}
              </Text>}
    
        </div>
      </div>
    }
    >
  <iframe
          height={window.screen.height - (window.screen.height / 100) * 35}
          width={window.screen.width - (window.screen.width / 100) * 38}
          src={this.state.medical_test_data}
        ></iframe>
    </Drawer>
  )
}

      
      publishPrescription = (publish_data) =>{
        message.warning("Please wait few seconds, generating PDF...", ErrorDuration); 
        api.publish_prescription(publish_data)
                .then((res)=>{        
            if(res.status==200){
              this.setState({open_publish_modal:false})
              typeof this.props.prescriptionReportFunction == "function" && this.props.prescriptionReportFunction();
              typeof this.props?.visiblePublish == "function" &&
              this.props.visiblePublish(false);
              message.warning(res.data?.message, ErrorDuration);
              this.setState({updateData:true, alreadyPublished : true, buttonLoading: false,visible_publish:false});
            }
                })
      }
      closePopup = () => {
        this.setState({open_publish_modal:false})
      }
        
  render() {
   
    return (
      <div className="med-test-tab">
       
          <MedicalTestform  
              test_name={this.state.test_name}  
              update_test={this.update_test} 
              // search_suggestion={data} 
              edit_array={this.state.edit_array} 
              is_edit={this.state.is_edit} 
              add_test={this.add_test}
              formAction={this.props.formAction}
              is_prescription_report={this.state?.is_prescription_report || this.props?.is_prescription_report}
             />

        <MedicalTestTable 
            test_name={this.state.test_name} 
            form_saved={this.state.form_saved} 
            edit_test={this.edit_test} 
            edit_array={this.state.edit_array}  
            test_array={this.state.test_array}
            is_edit={this.state.is_edit} 
            saveTest={this.saveTest}
            retain_test={this.state.t_table_data}
            is_prescription_report={this.state?.is_prescription_report || this.props?.is_prescription_report}
            is_save={this.state.is_save}
          
          
        />
    {this.state.preview_medical_test == true ? this.openPreview() : ""}
    {this.state?.open_publish_modal?
            <PublishPrescriptionPopup
             app_id={this.props.appointment_id}
             open_publish_modal={this.state.open_publish_modal}
             closePopup={this.closePopup}
             publishPrescription={this.publishPrescription}
             buttonLoading={this.state.buttonLoading}
             />:null}
      </div>
    )
  }
}
const mapStateToProps = state => {
 
  return {
    t_table_data: state.medicaltestReducer.medical_test_table ,
    allow_switchTab: state.tabsReducer.switch_tab,
    switch_prescription_tabs: state.tabsReducer.switch_prescription_tabs
  }
}
const mapDispatchToProps = {
addMedicalTest,
  switchPrescriptionTabs,
  currentPrescriptionTab,
  setPublishClicked
}

export default connect(mapStateToProps, mapDispatchToProps)(MedicalTestTab); 